import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-registration-success-component',
  imports: [MatCardModule, CommonModule],
  templateUrl: './registration-success-component.html',
  styleUrl: './registration-success-component.css'
})
export class RegistrationSuccessComponent {
  registrationId: string | null = null;
  userType: string | null = null;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.registrationId = this.route.snapshot.paramMap.get('id');
    this.userType = this.route.snapshot.paramMap.get('usertype');
    console.log(' this.userType', this.userType);
    
  }
}
